// @flow
import { FormattedCurrency } from "../../../../../../components/FormattedCurrency/FormattedCurrency";

export const columns = [
  {
    name: "Borough",
    accessor: "location_html",
  },
  {
    name: "Avg. days on the market",
    accessor: "days_on_market",
  },
];

export const currencyFormatter = (value: string) => (
  <FormattedCurrency
    value={value}
    minimumFractionDigits={2}
    maximumFractionDigits={2}
    currency="GBP"
  />
);

// Data hard coded for now. Should come from backend.
export const rows = [
  {
    location_html: "Southwark",
    days_on_market: 226,
    cost: 1004993.17,
    rental: 3128.67,
    airbnb: 11212,
  },
  {
    location_html: "Croydon",
    days_on_market: 120,
    cost: 499699.84,
    rental: 1529.5,
    airbnb: 5294,
  },
  {
    location_html: "Bexley",
    days_on_market: 81,
    cost: 416416,
    rental: 1330,
    airbnb: 4043,
  },
  {
    location_html: "Newham",
    days_on_market: 141,
    cost: 546533.83,
    rental: 1650.33,
    airbnb: 5205,
  },
  {
    location_html: "Barking & Dagenham",
    days_on_market: 112,
    cost: 363926.5,
    rental: 1494,
    airbnb: 3227.04,
  },
  {
    location_html: "Richmond upon Thames",
    days_on_market: 124,
    cost: 917416.5,
    rental: 2348.75,
    airbnb: 8108,
  },
  {
    location_html: "Hillingdon",
    days_on_market: 128,
    cost: 511874.5,
    rental: 1582.83,
    airbnb: 4055,
  },
  {
    location_html: "Havering",
    days_on_market: 114,
    cost: 380121.5,
    rental: 1387.67,
    airbnb: 2997.37,
  },
  {
    location_html: "Harrow",
    days_on_market: 120,
    cost: 595437.83,
    rental: 1717.33,
    airbnb: 4540,
  },
  {
    location_html: "Tower Hamlets",
    days_on_market: 155,
    cost: 711447.67,
    rental: 2170.17,
    airbnb: 5337,
  },
  {
    location_html: "Lambeth",
    days_on_market: 218,
    cost: 971160.17,
    rental: 3052.83,
    airbnb: 7111,
  },
  {
    location_html: "Sutton",
    days_on_market: 98,
    cost: 520136.83,
    rental: 1608.33,
    airbnb: 3473.99,
  },
  {
    location_html: "Enfield",
    days_on_market: 98,
    cost: 643156.67,
    rental: 1900,
    airbnb: 4127,
  },
  {
    location_html: "Redbridge",
    days_on_market: 109,
    cost: 561647,
    rental: 1591.83,
    airbnb: 3438.35,
  },
  {
    location_html: "Ealing",
    days_on_market: 143,
    cost: 673998.33,
    rental: 2047.16,
    airbnb: 3937,
  },
  {
    location_html: "Greenwich",
    days_on_market: 148,
    cost: 566114.33,
    rental: 1652.17,
    airbnb: 3281,
  },
  {
    location_html: "Camden",
    days_on_market: 218,
    cost: 1600460,
    rental: 3950.14,
    airbnb: 9088,
  },
  {
    location_html: "Bromley",
    days_on_market: 107,
    cost: 533737.67,
    rental: 1570.33,
    airbnb: 2987,
  },
  {
    location_html: "Kingston upon Thames",
    days_on_market: 126,
    cost: 668136.67,
    rental: 2049.83,
    airbnb: 3698,
  },
  {
    location_html: "Wandsworth",
    days_on_market: 168,
    cost: 1032831.17,
    rental: 3169.29,
    airbnb: 5536,
  },
  {
    location_html: "Hounslow",
    days_on_market: 121,
    cost: 556134.33,
    rental: 1746.5,
    airbnb: 2946,
  },
  {
    location_html: "City of Westminster",
    days_on_market: 230,
    cost: 2318385,
    rental: 5481.6,
    airbnb: 12195,
  },
  {
    location_html: "Lewisham",
    days_on_market: 131,
    cost: 635800.17,
    rental: 1681.67,
    airbnb: 3190,
  },
  {
    location_html: "Haringey",
    days_on_market: 165,
    cost: 970126.33,
    rental: 2665,
    airbnb: 4798,
  },
  {
    location_html: "Brent",
    days_on_market: 164,
    cost: 690623.84,
    rental: 2089.4,
    airbnb: 3342,
  },
  {
    location_html: "Merton",
    days_on_market: 120,
    cost: 751328.5,
    rental: 2241.67,
    airbnb: 3478,
  },
  {
    location_html: "Hackney",
    days_on_market: 123,
    cost: 946368.17,
    rental: 2572.33,
    airbnb: 4391,
  },
  {
    location_html: "Hammersmith & Fulham",
    days_on_market: 179,
    cost: 1225003.5,
    rental: 3286,
    airbnb: 5535,
  },
  {
    location_html: "Waltham Forest",
    days_on_market: 86,
    cost: 639300.17,
    rental: 1770,
    airbnb: 2886,
  },
  {
    location_html: "Barnet",
    days_on_market: 139,
    cost: 745791.5,
    rental: 2166.83,
    airbnb: 3340,
  },
  {
    location_html: "City of London",
    days_on_market: 160,
    cost: 1981250,
    rental: 4441.5,
    airbnb: 8860,
  },
  {
    location_html: "Islington",
    days_on_market: 177,
    cost: 1159734.33,
    rental: 3234,
    airbnb: 5160,
  },
  {
    location_html: "Kensington & Chelsea",
    days_on_market: 202,
    cost: 3593168,
    rental: 7240,
    airbnb: 9455,
  },
];
